import {
  FaAward,
  FaClock,
  FaExclamationCircle,
  FaTrophy,
  FaStar,
  FaCheckCircle,
  FaPlay,
  FaDownload,
} from "react-icons/fa";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

const ExamInstructions = ({
  title,
  subtitle,
  duration,
  questions,
  passScore,
  validity,
  instructions,
  topics,
  link,
}) => {

  const navigate = useNavigate();

  const handleStartExam = () => {
    if (link) {
      navigate(`/${link}`);
    } else {
      alert("Quiz not available for this certificate.");
    }
  };

  
  return (
    <div className="col-lg-8 mb-4">
      <div className="rounded-lg border shadow bg-dark text-light p-4">
        {/* Header */}
        <div className="d-flex align-items-center mb-4">
          <FaAward className="text-primary me-3" size={32} />
          <div>
            <h4 className="fw-bold mb-1">{title}</h4>
            <p className="text-muted mb-0">{subtitle}</p>
          </div>
        </div>

        {/* Exam Details */}
        <div className="row mx-0 mb-4">
          <div className="col-md-3 mb-3">
            <div className="text-center p-3 bg-dark rounded">
              <FaClock className="text-primary mb-2" size={24} />
              <h6 className="mb-1">{duration}</h6>
              <small className="text-muted">Duration</small>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="text-center p-3 bg-dark rounded">
              <FaExclamationCircle className="text-warning mb-2" size={24} />
              <h6 className="mb-1">{questions}</h6>
              <small className="text-muted">Questions</small>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="text-center p-3 bg-dark rounded">
              <FaTrophy className="text-success mb-2" size={24} />
              <h6 className="mb-1">{passScore}</h6>
              <small className="text-muted">Pass Score</small>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="text-center p-3 bg-dark rounded">
              <FaStar className="text-info mb-2" size={24} />
              <h6 className="mb-1">{validity}</h6>
              <small className="text-muted">Valid</small>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Exam Instructions</h5>
          <div className="bg-dark p-3 rounded">
            <ul className="list-unstyled mb-0">
              {instructions.map((item, index) => (
                <li key={index} className="d-flex align-items-start mb-2">
                  {index === instructions.length - 1 ? (
                    <FaExclamationCircle
                      className="text-warning me-2 mt-1"
                      size={16}
                    />
                  ) : (
                    <FaCheckCircle
                      className="text-success me-2 mt-1"
                      size={16}
                    />
                  )}
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Topics */}
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Topics Covered</h5>
          <div className="row mx-0">
            {topics.map((topic, index) => (
              <div key={index} className="col-md-6 mb-2">
                <div className="d-flex align-items-center">
                  <FaCheckCircle className="text-success me-2" size={16} />
                  <span>{topic}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex gap-3">
          <Button variant="gradient" fullWidth onClick={handleStartExam}>
            <FaPlay className="me-2" /> Start Certification Exam
          </Button>

          <button className="btn btn-outline-light">
            <FaDownload className="me-2" /> Study Guide
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamInstructions;
